

/**
 * Validates that a value is not empty
 */
export const required = (value, field) => {
  if (!value || (typeof value === 'string' && value.trim() === '')) {
    return `${field.label} is required`;
  }
  return null;
};

/**
 * Validates that a date is not in the future
 */
export const notFutureDate = (value, field) => {
  if (!value) return null; 
  
  const selectedDate = new Date(value);
  const today = new Date();
  
  // Set time to start of day for fair comparison
  today.setHours(0, 0, 0, 0);
  selectedDate.setHours(0, 0, 0, 0);
  
  if (selectedDate > today) {
    return `${field.label} cannot be a future date`;
  }
  
  return null;
};

/**
 * Map of validator names to functions
 */
export const validators = {
  required,
  notFutureDate,
};

/**
 * Validates a single field value
 */
export const validateField = (value, field) => {
  if (!field.validations || field.validations.length === 0) {
    return null;
  }
  
  for (const validation of field.validations) {
    let error = null;
    
    // Handle string validator name (e.g., "required")
    if (typeof validation === 'string') {
      const validator = validators[validation];
      if (validator) {
        error = validator(value, field);
      }
    }
    
    // Return first error found
    if (error) {
      return error;
    }
  }
  
  return null;
};